<template>
	<AtomInputUtilWrapper
		:title="title"
		:is-required="isRequired"
		:error-messages="errorMessages"
	>
		<input
			v-model="model"
			type="text"
			:class="[
				'w-full h-16 rounded border py-3.5 shadow-sm px-3 border-gray-300',
				'focus:outline-0 focus:ring-2 focus:ring-offset-2 focus:ring-purple-500',
				'text-gray-900 placeholder:text-gray-400 text-functional-size-md leading-6',
				errorMessages.length > 0
					? 'ring-2 ring-offset-2 ring-red-500'
					: '',
			]"
			:data-test-error="errorMessages.length > 0 ? true : undefined"
			:title="title"
			:name="name"
			:placeholder="placeholder"
			:maxlength="maxLength"
			:minlength="minLength"
			:disabled="isDisabled"
			:readonly="isReadonly"
			:required="isRequired"
			@focusout="(e) => validate((e.target as HTMLInputElement).value)"
		>
	</AtomInputUtilWrapper>
</template>

<script setup lang="ts">
import type { InputPropDefaultsType } from '#base/core/types/InputPropDefaultsType';
import validatorStringInput from '#base/helpers/validators/validatorStringInput';

const props = defineProps<
	InputPropDefaultsType & {
		title: string;
		maxLength?: number;
		minLength?: number;
	}
>();

const model = defineModel<string>();

const errorMessages = ref<string[]>([]);

function validate(value: string) {
	errorMessages.value = [
		...validatorStringInput(value, {
			isRequired: props.isRequired,
			isDisabled: props.isDisabled,
			fieldName: props.title,
		}),
	];
}
</script>
